// File: garage-banner.js
// Version: 2.12

(function() {
  // Helper: turn a sanitized key like "FLHR_Road_King" into a display label "FLHR Road King"
  function displayLabelFromKey(key) {
    return key.replace(/_/g, " ");
  }

  // Cache DOM elements
  const banner     = document.getElementById("active-vehicle-banner");
  const bannerText = document.getElementById("active-vehicle-text");
  const clearBtn   = document.getElementById("clear-active-vehicle");

  // Apply initial border and padding styling
  banner.style.border       = "1px solid #ffffff";
  banner.style.padding      = ".5em 1em";
  banner.style.borderRadius = "4px";

  /**
   * showActiveBanner(key):
   *   - key is the combined string “YEAR_MAKE_MODEL”
   *   - writes it to localStorage.activeVehicle
   *   - updates the bannerText and shows the banner
   */
  window.showActiveBanner = function(key) {
    const parts = key.split("_");
    const year  = parts[0];
    const make  = parts[1];
    const model = parts.slice(2).join(" ");
    bannerText.innerHTML = `<em>Shopping for:</em> ${year} ${make} ${model}`;
    bannerText.style.fontSize = "1em";
    banner.style.display = "block";
    localStorage.setItem("activeVehicle", key);
  };

  /** hideBanner(): hides the banner and clears localStorage.activeVehicle */
  function hideBanner() {
    localStorage.removeItem("activeVehicle");
    banner.style.display = "none";
  }

  /** renderBannerOnLoad(): rehydrates banner from localStorage */
  function renderBannerOnLoad() {
    const key = localStorage.getItem("activeVehicle");
    if (!key) {
      banner.style.display = "none";
      return;
    }
    const parts = key.split("_");
    bannerText.innerHTML = `<em>Shopping for:</em> ${parts[0]} ${parts[1]} ${parts.slice(2).join(" ")}`;
    bannerText.style.fontSize = "1em";
    banner.style.display = "block";
  }

  // Hook up the “×” button
clearBtn.addEventListener("click", () => {
  hideBanner();
  const url = new URL(window.location.href);
  url.searchParams.delete("filter.p.m.custom.vehicle_fitment_combos");
  window.location.href = url.pathname + url.search;
});

  // On initial page load, render the banner if needed
  document.addEventListener("DOMContentLoaded", renderBannerOnLoad);
})();